import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import {
  GlTransactionPostedByFilter,
  GlTransactionRowSortField,
  GlTransactionRowType,
  GlTransactionStatus,
  SortingOrder,
} from "@/graphql/codegen/graphql"

export enum GlTransactionDateType {
  CreatedDate = "CREATED_DATE",
  TransactionDate = "TRANSACTION_DATE",
}

export const transactionsSearchParamsSchema = z.object({
  query: fallback(z.string().optional().default(""), ""),
  field: fallback(z.nativeEnum(GlTransactionRowSortField), GlTransactionRowSortField.TransactionDate).optional(),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc).optional(),
  transactionType: z.nativeEnum(GlTransactionRowType).optional(),
  statuses: z.array(z.nativeEnum(GlTransactionStatus)).optional(),
  postedByType: z.nativeEnum(GlTransactionPostedByFilter).optional(),
  dateType: z.nativeEnum(GlTransactionDateType).optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
})

export type TransactionsSearchParams = z.infer<typeof transactionsSearchParamsSchema>
